var _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Shopping-Advertising-Audience-Targer-User--Streamline-Ultimate",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Shopping Advertising Audience Targer User Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 4.174V0.75",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 23.25v-3.424",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.174 12H0.75",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23.25 12h-3.424",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.74194 9.11597c0 0.59886 0.2379 1.17323 0.66136 1.59663 0.4235 0.4235 0.9978 0.6614 1.5966 0.6614 0.5989 0 1.1732 -0.2379 1.5967 -0.6614 0.4234 -0.4234 0.6613 -0.99777 0.6613 -1.59663s-0.2379 -1.17319 -0.6613 -1.59665c-0.4235 -0.42345 -0.9978 -0.66135 -1.5967 -0.66135 -0.5988 0 -1.1731 0.2379 -1.5966 0.66135 -0.42346 0.42346 -0.66136 0.99779 -0.66136 1.59665Z",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.96899 16.641c0 -1.0691 0.4247 -2.0944 1.18066 -2.8504C9.90561 13.0347 10.9309 12.61 12 12.61c1.0691 0 2.0944 0.4247 2.8503 1.1806 0.756 0.756 1.1807 1.7813 1.1807 2.8504H7.96899Z",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.48206 12c0 2.5196 1.00089 4.9359 2.78248 6.7175C7.04614 20.4991 9.4625 21.5 11.9821 21.5c2.5195 0 4.9359 -1.0009 6.7175 -2.7825 1.7816 -1.7816 2.7825 -4.1979 2.7825 -6.7175 0 -2.51956 -1.0009 -4.93592 -2.7825 -6.71751C16.918 3.50089 14.5016 2.5 11.9821 2.5c-2.5196 0 -4.93596 1.00089 -6.71756 2.78249C3.48295 7.06408 2.48206 9.48044 2.48206 12Z",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9f690925ca7fb7f42fea34ab8b833774.svg";
export { ForwardRef as ReactComponent };